import { Controller } from 'react-hook-form';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import LoadingCard from '../../components/LoadingCard';
import AdminPage from '../../components/admin/AdminPage';
import useDevManagement from './hooks/useDevManagement';
import SweetAlert from 'react-bootstrap-sweetalert';

const InvestorConfigDevManagement = () => {

  const pageName = 'Administrar Desarrolladoras';
  const pageParentName = 'Inversiones';
  const {
    handleSubmit,
    onSubmit,
    control,
    errors,
    editingId,
    reset,
    setEditingId,
    isLoading,
    sweetAlert,
    alertProps,
    handleEdit,
    searchQuery,
    setSearchQuery,
    filteredResults,
    uploadAvatar
  } = useDevManagement();

  if (isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage name={pageName} parentName={pageParentName}>
      {sweetAlert && (
        <SweetAlert {...alertProps}>{alertProps.text || ''}</SweetAlert>
      )}
      <Row>
        {/* Table Column */}
        <Col md="6">
          <h5>Resultados</h5>
          <Input
            type="text"
            placeholder="Buscar por nombre"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mb-3"
          />
          <div
            style={{
              height: '500px',
              overflow: 'auto',
            }}
          >
            <Table className="align-items-center" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredResults.length > 0 ? (
                  filteredResults.map((result) => (
                    <tr key={result.id}>
                      <td>{result.name}</td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-secondary"
                            href="#"
                            role="button"
                            size="sm"
                            color=""
                            caret
                            onClick={(e) => e.preventDefault()}
                          >
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right container='body'>
                            <DropdownItem onClick={() => handleEdit(result.id)}>
                              Editar
                            </DropdownItem>
                            <DropdownItem
                              href={`/investors/configs/dev-management/${result.id}/upload-images`}>
                              Subir Avatar
                            </DropdownItem>
                            <DropdownItem
                              href={`/investors/configs/dev-management/${result.id}/users`}>
                              Gestionar Usuarios
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No hay resultados que coincidan con la búsqueda
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>

        {/* Form Column */}
        <Col md="6">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Label for="name">Desarrolladora</Label>
              <Controller
                name="name"
                control={control}
                rules={{
                  required: 'El nombre es obligatorio',
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    id="name"
                    type="text"
                    placeholder="Ingrese el nombre"
                    className={errors.name ? 'is-invalid' : ''}
                  />
                )}
              />
              {errors.name && (
                <div className="text-danger">{errors.name.message}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label for="description">Descripción</Label>
              <Controller
                name="description"
                control={control}
                rules={{
                  required: 'La descripción es obligatorio',
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    id="description"
                    type="textarea"
                    placeholder="Ingrese la descripción"
                    className={errors.description ? 'is-invalid' : ''}
                  />
                )}
              />
              {errors.description && (
                <div className="text-danger">{errors.description.message}</div>
              )}
            </FormGroup>
            <Button color="primary" type="submit">
              {editingId !== null ? 'Actualizar' : 'Guardar'}
            </Button>
            {editingId !== null && (
              <Button
                color="success"
                type="button"
                onClick={() => uploadAvatar(editingId)}
                className="ms-2"
              >
                Actualizar Avatar
              </Button>
            )}

            {editingId !== null && (
              <Button
                color="secondary"
                type="button"
                onClick={() => {
                  reset(); // Reset the form
                  setEditingId(null); // Clear editing state
                }}
                className="ms-2"
              >
                Cancelar
              </Button>

            )}


          </Form>
        </Col>
      </Row>
    </AdminPage>
  );
};

export default InvestorConfigDevManagement;